import React, { useEffect } from 'react';
import Notifications from '../profile/Notifications';
import Subscriptions from '../profile/Subscribtions';
import { trackEvent, GA_EVENTS } from '../../utils/analytics';

const Profile = () => {
    // Track subscription management page view
    useEffect(() => {
        trackEvent(GA_EVENTS.VIEW_SUBSCRIPTION_MANAGEMENT, {
            page_location: window.location.href,
            page_path: '/profile'
        });
    }, []);

    return (
        <div className="bg-white dark:bg-brand-dark-900 h-full overflow-y-auto p-4">
            <div className="max-w-7xl mx-auto space-y-6">
                <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
                    Profile Settings
                </h1>
                <div className="grid gap-6 md:grid-cols-2">
                    <div className="bg-white dark:bg-brand-dark-800 rounded-lg shadow p-6 border border-gray-200 dark:border-brand-dark-700">
                        <Subscriptions />
                    </div>
                    <div className="bg-white dark:bg-brand-dark-800 rounded-lg shadow p-6 border border-gray-200 dark:border-brand-dark-700">
                        <Notifications />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;